import axios from 'axios';

export const baseAPIURL = process.env.REACT_APP_API_URL || '';
const CONTENT_TYPE = 'application/json';

const headers = {
  Accept: CONTENT_TYPE,
  'Content-type': CONTENT_TYPE,
};

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.withXSRFToken = true;

const api = axios.create({
  headers,
  baseURL: baseAPIURL,
  withCredentials: true,
});

export default api;
